/**
 * feeConfigurationUtils.ts
 * Utility functions and types for fee configuration management
 */

// Loading state enum to replace multiple boolean flags
export enum FeeConfigurationLoadingState {
  IDLE = 'idle',
  INITIALIZING = 'initializing',
  LOADING_CATALOG = 'loading_catalog',
  READY = 'ready',
  ERROR = 'error'
}

// Legacy functions removed - hierarchy operations now handled by tree-based useFeeHierarchy hook
// Validation simplified and moved to FeeConfigurationContainer